import { render } from "./isdurumForm.vue?vue&type=template&id=8ffaf29c"
import script from "./isdurumForm.vue?vue&type=script&lang=js"
export * from "./isdurumForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__